import classNames from 'classnames';
import React from 'react';
import styles from './button.module.scss';

type ButtonEl = React.ElementRef<'button'>;

interface ButtonProps {
  children: React.ReactElement;
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'full' | 'icon';
  variant?: 'primary' | 'secondary' | 'neutral';
  disabled?: boolean;
  onClick?: () => void;
}

const Button = React.forwardRef<ButtonEl, ButtonProps>(({
  children,
  className,
  size = 'medium',
  variant = 'primary',
  ...rest
}, forwardedRef) => {
  return (
    <button
      {...rest}
      ref={forwardedRef}
      data-size={size}
      data-variant={variant}
      className={classNames(styles.button, className)}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
